import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useProgress } from "../lib/progress";
import { hrefFor } from "../lib/router";
import { CheckIcon, XIcon } from "./Icons";

function LevelSidebar({ track, currentLevelId, open, onClose }) {
  const { t } = useTranslation();
  const { solved } = useProgress();
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    closeRef.current?.focus();
    const onKey = (event) => event.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <>
      <div className={`drawer-backdrop ${open ? "is-open" : ""}`} onClick={onClose} aria-hidden="true" />
      <nav
        id="level-sidebar"
        className={`drawer ${open ? "is-open" : ""}`}
        aria-label={t("level.openList")}
        aria-hidden={!open}
        inert={!open}
      >
        <div className="drawer__header">
          <strong>{track.title}</strong>
          <button ref={closeRef} type="button" className="icon-button" onClick={onClose} aria-label={t("level.closeList")}>
            <XIcon />
          </button>
        </div>
        <div className="drawer__body">
          {track.chapters.map((chapter) => (
            <section key={chapter.id} className="drawer__chapter">
              <h3>{chapter.title}</h3>
              <ul>
                {chapter.levels.map((level) => {
                  const isCurrent = level.id === currentLevelId;
                  const isSolved = Boolean(solved[level.id]);
                  return (
                    <li key={level.id}>
                      <a
                        href={hrefFor(track.id, level.id)}
                        className={`drawer__level ${isCurrent ? "is-current" : ""} ${isSolved ? "is-solved" : ""}`}
                        aria-current={isCurrent ? "page" : undefined}
                      >
                        <span className="level-row__status">{isSolved && <CheckIcon size={11} strokeWidth={3} />}</span>
                        {level.title}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
        </div>
      </nav>
    </>
  );
}

export default LevelSidebar;
